import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '@/store'
import router from '@/router'

let isReloginShowing = false

const service = axios.create({
  baseURL: 'https://wozhoujt.cn',
  timeout: 600000
})

service.interceptors.request.use(
  config => {
    const isAdminApi = config.url && (config.url.startsWith('/admin') || config.url.startsWith('/api/admin')|| config.url.startsWith('/api/me'))
    const isUploadApi = config.url && config.url.startsWith('/api/upload')
    let token = ''
    if (isAdminApi || isUploadApi) {
      token = store.getters.adminToken
    } else {
      token = store.getters.token
    }
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

function handle401() {
  if (isReloginShowing) return
  isReloginShowing = true
  MessageBox.confirm('登录凭证已过期，请重新登录', '系统提示', {
    confirmButtonText: '重新登录',
    cancelButtonText: '取消',
    type: 'warning',
    closeOnClickModal: false,
    closeOnPressEscape: false
  }).then(() => {
    isReloginShowing = false
    store.dispatch('logout').then(() => {
      const isAdmin = store.getters.isAdmin
      router.push(isAdmin ? '/admin/login' : '/login')
    })
  }).catch(() => {
    isReloginShowing = false
  })
}

service.interceptors.response.use(
  response => {
    if (response.config.responseType === 'blob') {
      console.log(response)
      return response.data
    }
    const res = response.data
    if (res.code && res.code !== 200) {
      if (res.code === 401) {
        handle401()
        return Promise.reject(new Error(res.message || '登录凭证无效'))
      }
      Message({
        message: res.message || '请求错误',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(new Error(res.message || '请求错误'))
    }
    return res
  },
  error => {
    if (error.response && error.response.status === 401) {
      handle401()
      return Promise.reject(new Error('登录凭证无效，请重新登录'))
    }
    Message({
      message: error.message || '网络错误',
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
